module.exports = __webpack_public_path__ + "static/img/3825_phase_function_Paper_PointsHejduk_Prediction.1b71edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3825_phase_function_Paper_PointsHejduk_Prediction.png
// module id = lVI6
// module chunks = 0